import request from "@/utils/request";

export function wxUserInfo(token) {
  return request({
    url: "/api/app-invitation/v1/wechat/login",
    method: "post",
    data: {
      token
    }
  });
}

export function login(data) {
  return request({
    url: "/api/v1/login",
    method: "post",
    data
  });
}

export function logout() {
  return Promise.resolve();
}
